// @ts-nocheck fff

/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useIntl} from 'react-intl'
import axios from 'axios'
import {useState, useEffect} from 'react'
import {WithContext as ReactTags, SEPARATORS} from 'react-tag-input';

const API_URL = process.env.REACT_APP_API_URL

function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'm';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  } else {
    return num?.toString() || '0';
  }
}

// Clean display name by removing "אריה מסונן בע"ה" suffix (works for campaign names and library names)
function cleanDisplayName(name) {
  if (!name) return '';
  return name
    .replace(/\s*[-–—]\s*אריה מסונן בע"ה\s*$/i, '')
    .replace(/\s*אריה\s+מסונן בע"ה\s*$/i, '')
    .replace(/\s*אריה מסונן בע"ה\s*$/i, '')
    .replace(/\s*אריה\s*מסונן\s*בע"ה\s*$/i, '')
    .trim();
}

const TablesWidget10: React.FC<Props> = ({campaign, className, ddddddddddd, currentUser, onOccupationSave, isAdmin}) => {
  const intl = useIntl()

  // ── Core campaign state (kept) ──
  const [campaignGroups, setCampaignGroups] = useState(campaign.groups || []);
  const [campaignLibraryGroups, setCampaignLibraryGroups] = useState(campaign.library_groups || []);
  const [campaignBlacklistedGroups, setCampaignBlacklistedGroups] = useState(campaign.blacklisted_groups || []);
  const [saved, setSaved] = useState(false);
  const [campaignUsers, setCampaignUsers] = useState<string[]>([]);

  const [suggestedLibrary, setSuggestedLibrary] = useState<any>(null);

  // Occupation state
  const [libraryOccupation, setLibraryOccupation] = useState<string | null>(null);
  const [loadingOccupation, setLoadingOccupation] = useState(true);
  const [savingOccupation, setSavingOccupation] = useState(false);

  // Library selection state
  const [publicLibraries, setPublicLibraries] = useState<any[]>([]);
  const [selectedLibraryIds, setSelectedLibraryIds] = useState<string[]>([]);
  // Libraries switched OFF in this campaign: kept in the list (shown as "מושהה") but not
  // published to. Switching a library off used to delete it from the campaign entirely.
  const [pausedLibraryIds, setPausedLibraryIds] = useState<string[]>([]);
  const [allLibraryGroups, setAllLibraryGroups] = useState<any[]>([]);
  const [loadingLibraries, setLoadingLibraries] = useState(false);
  const [loadingLibraryGroups, setLoadingLibraryGroups] = useState(false);
  const [aiSelectingLibrary, setAiSelectingLibrary] = useState(false);
  const [aiSuggestionAccepted, setAiSuggestionAccepted] = useState<boolean | null>(null);
  const [libraryError, setLibraryError] = useState<{message: string, ticketNumber?: string, requestedCity?: string} | null>(null);
  const [slotLoaded, setSlotLoaded] = useState(false);

  // Slot libraries: public libraries assigned to this campaign (by admin or AI)
  const [slotLibraries, setSlotLibraries] = useState<any[]>([]);

  // Admin: public library picker popup
  const [showPublicLibraryPicker, setShowPublicLibraryPicker] = useState(false);
  const [publicLibrarySearch, setPublicLibrarySearch] = useState('');

  // Private library management state
  const [myLibraries, setMyLibraries] = useState<any[]>([]);
  const [loadingMyLibraries, setLoadingMyLibraries] = useState(false);
  const [savingLibrary, setSavingLibrary] = useState(false);
  const [savingLibrarySelection, setSavingLibrarySelection] = useState(false);
  const [librarySaved, setLibrarySaved] = useState(false);
  const [perLibraryGroups, setPerLibraryGroups] = useState<Record<string, any[]>>({});

  // ── NEW: Two-view state machine ──
  const [activeView, setActiveView] = useState<
    | { type: 'library-list' }
    | { type: 'edit-library'; libraryId: string; libraryName: string; isPublic: boolean }
    | { type: 'create-library' }
  >({ type: 'library-list' });

  // Edit view states
  const [editViewGroups, setEditViewGroups] = useState<any[]>([]);
  const [editViewGroupsHasMore, setEditViewGroupsHasMore] = useState(false);
  const [editViewGroupsTotal, setEditViewGroupsTotal] = useState(0);
  const [editViewGroupsLoading, setEditViewGroupsLoading] = useState(false);
  const [editViewSearchResults, setEditViewSearchResults] = useState<any[]>([]);
  const [editViewSearchLoading, setEditViewSearchLoading] = useState(false);
  const [editViewLibraryName, setEditViewLibraryName] = useState('');
  const [editViewFilterBy, setEditViewFilterBy] = useState('keywords');
  const [myGroupsProfiles, setMyGroupsProfiles] = useState<any[]>([]);
  const [myGroupsSelectedProfile, setMyGroupsSelectedProfile] = useState<string>('all');

  // Account-scoped extra groups added to a PUBLIC library (this account only).
  const [acctLibGroups, setAcctLibGroups] = useState<any[]>([]); // [{_id,name,image_url,follow_count}]
  // Search results are appended BELOW the library's own groups, which on a large library is
  // far past the fold — the search looked like it had returned nothing. Scroll to them once
  // per query, so a second search moves you again but re-renders (adding a group, say)
  // don't yank the list while you're working through the results.
  const globalResultsAnchorRef = React.useRef<HTMLDivElement | null>(null);
  const lastScrolledQueryRef = React.useRef<string>('');
  const [acctLibSearch, setAcctLibSearch] = useState('');
  const [acctLibResults, setAcctLibResults] = useState<any[]>([]);
  const [acctLibSearching, setAcctLibSearching] = useState(false);
  const [acctLibBusy, setAcctLibBusy] = useState(false);
  // How many account-only extras each library carries, so the library card's group
  // count includes them instead of showing only the shared library's own groups.
  const [acctLibCounts, setAcctLibCounts] = useState<{[libraryId: string]: number}>({});

  // Naming dialog for legacy groups
  const [showNamingDialog, setShowNamingDialog] = useState(false);
  const [legacyLibraryName, setLegacyLibraryName] = useState('');

  // Edit view search tags
  const [tags, setTags] = React.useState<Array<Tag>>([]);
  const [searchInputValue, setSearchInputValue] = React.useState('');

  const handleDelete = (index: number) => {
    setTags(tags.filter((_, i) => i !== index));
  };

  const onTagUpdate = (index: number, newTag: Tag) => {
    const updatedTags = [...tags];
    updatedTags.splice(index, 1, newTag);
    setTags(updatedTags);
  };

  const handleAddition = (tag: Tag) => {
    setTags((prevTags) => {
      return [...prevTags, tag];
    });
    setSearchInputValue('');
  };

  const handleDrag = (tag: Tag, currPos: number, newPos: number) => {
    const newTags = tags.slice();
    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);
    setTags(newTags);
  };

  const handleTagClick = (index: number) => {};

  const onClearAll = () => {
    setTags([]);
  };

  const handleSearchInputChange = (value: string) => {
    setSearchInputValue(value);
  };

  const handleAddTagClick = () => {
    if (searchInputValue.trim()) {
      handleAddition({ id: searchInputValue.trim(), text: searchInputValue.trim() });
    }
  };

  // ── View transition functions ──
  const openEditView = (libraryId: string, libraryName: string, isPublic: boolean) => {
    setEditViewLibraryName(libraryName);
    setEditViewSearchResults([]);
    setEditViewSearchLoading(false);
    setTags([]);
    setSearchInputValue('');
    setEditViewFilterBy('keywords');
    // Load library groups
    const existing = perLibraryGroups[libraryId];
    if (existing) {
      setEditViewGroups(existing);
      setEditViewGroupsHasMore(false);
      setEditViewGroupsTotal(existing.length);
      setEditViewGroupsLoading(false);
    } else {
      setEditViewGroups([]);
      setEditViewGroupsHasMore(false);
      setEditViewGroupsTotal(0);
      setEditViewGroupsLoading(true);
      axios.get(`${API_URL}/api/library-groups/${libraryId}?limit=500`).then(res => {
        if (res.data.success) {
          const groups = res.data.groups || [];
          setEditViewGroups(groups);
          setEditViewGroupsHasMore(res.data.has_more || false);
          setEditViewGroupsTotal(res.data.total_in_library || groups.length);
          setPerLibraryGroups(prev => ({ ...prev, [libraryId]: groups }));
        }
        setEditViewGroupsLoading(false);
      });
    }
    // Account-scoped extras only apply to PUBLIC libraries (you can't extend your own private one this way).
    setAcctLibGroups([]); setAcctLibSearch(''); setAcctLibResults([]);
    if (isPublic) {
      axios.get(`${API_URL}/api/account-library-groups/${libraryId}`)
        .then(res => {
          if (!res.data?.success) return;
          const groups = res.data.groups || [];
          setAcctLibGroups(groups);
          setAcctLibCounts(prev => ({...prev, [libraryId]: groups.length}));
        })
        .catch(() => {});
    }
    setActiveView({ type: 'edit-library', libraryId, libraryName, isPublic });
  };

  // The MAIN keyword search doubles as a global "search all groups" for public libraries:
  // whatever the user types is looked up across ALL groups so results not yet in the library
  // can be added to THIS account only (account_library_groups). Keyed off the main search box.
  React.useEffect(() => {
    if (!(activeView.type === 'edit-library' && activeView.isPublic)) { setAcctLibResults([]); return; }
    const q = (searchInputValue.trim() || tags.map((t: any) => (t.text || t.id || '')).join(' ')).trim();
    if (q.length < 2) { setAcctLibResults([]); return; }
    let cancelled = false;
    setAcctLibSearching(true);
    const timer = setTimeout(async () => {
      try {
        const r = await axios.get(`${API_URL}/api/account-library-groups-search`, { params: { q } });
        if (!cancelled) setAcctLibResults(r.data?.groups || []);
      } catch { if (!cancelled) setAcctLibResults([]); }
      finally { if (!cancelled) setAcctLibSearching(false); }
    }, 350);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [searchInputValue, tags, activeView]);

  const addAcctLibGroup = async (group: any) => {
    if (activeView.type !== 'edit-library') return;
    const libraryId = activeView.libraryId;
    setAcctLibBusy(true);
    try {
      const res = await axios.post(`${API_URL}/api/account-library-groups/${libraryId}/add`, { group_ids: [group._id.toString()] });
      setAcctLibGroups(prev => prev.some(g => g._id.toString() === group._id.toString()) ? prev : [...prev, group]);
      // Server returns the full overlay, so the card count tracks what was actually saved.
      setAcctLibCounts(prev => ({...prev, [libraryId]: (res.data?.groups || []).length}));
    } catch (e: any) {
      alert('הוספת הקבוצה נכשלה: ' + (e?.response?.data?.error || e?.message));
    } finally { setAcctLibBusy(false); }
  };

  const removeAcctLibGroup = async (groupId: string) => {
    if (activeView.type !== 'edit-library') return;
    const libraryId = activeView.libraryId;
    setAcctLibBusy(true);
    try {
      const res = await axios.post(`${API_URL}/api/account-library-groups/${libraryId}/remove`, { group_ids: [groupId] });
      setAcctLibGroups(prev => prev.filter(g => g._id.toString() !== groupId));
      setAcctLibCounts(prev => ({...prev, [libraryId]: (res.data?.groups || []).length}));
    } catch (e: any) {
      alert('הסרת הקבוצה נכשלה: ' + (e?.response?.data?.error || e?.message));
    } finally { setAcctLibBusy(false); }
  };

  const openCreateView = (prefillGroups?: any[]) => {
    setEditViewLibraryName('');
    setEditViewGroups(prefillGroups || []);
    setEditViewSearchResults([]);
    setEditViewSearchLoading(false);
    setTags([]);
    setSearchInputValue('');
    setEditViewFilterBy('keywords');
    setActiveView({ type: 'create-library' });
  };

  const goBackToList = () => {
    setActiveView({ type: 'library-list' });
    setEditViewGroups([]);
    setEditViewSearchResults([]);
    setTags([]);
    setSearchInputValue('');
  };

  // Check if a group is from any selected library
  const isLibraryGroup = (groupId) => {
    return allLibraryGroups.some(g => g._id === groupId);
  };

  // Get all selected group IDs (manual + library - blacklisted)
  const libraryGroupIds = allLibraryGroups.map(g => g._id);
  const allSelectedGroupIds = [...new Set([
    ...campaignGroups,
    ...libraryGroupIds
  ])].filter(id => !campaignBlacklistedGroups.includes(id));

  const selectedCount = allSelectedGroupIds.length;

  // Groups this account added to the selected libraries. They aren't in allLibraryGroups —
  // that's the shared library content — but the server merges the overlay in when it
  // expands the libraries, so they ARE published to. Counting them keeps the header, the
  // save button and the per-library breakdown agreeing with the library cards, which
  // already included them; the two disagreed by exactly the number added here.
  // Display only: allSelectedGroupIds stays as-is, since the overlay is applied server-side
  // and writing these ids into the campaign's own group list would duplicate them.
  const acctExtrasInSelected = selectedLibraryIds.reduce((n: number, id: any) => n + (acctLibCounts[id] || 0), 0);
  const selectedCountDisplay = selectedCount + acctExtrasInSelected;

  // Check if library features should be shown
  const showLibraryFeature = libraryOccupation && ['real_estate', 'cars', 'hr'].includes(libraryOccupation);
  const needsOccupationChoice = (libraryOccupation === null || libraryOccupation === 'other') && !loadingOccupation;

  // Combined list of all libraries (AI/public first, then slot public libs, then private)
  const suggestedId = suggestedLibrary?._id;
  // Slot libraries that aren't the AI suggestion and aren't private
  const myLibraryIds = new Set(myLibraries.map(l => l._id));
  const slotPublicLibs = slotLibraries.filter(l => l._id !== suggestedId && !myLibraryIds.has(l._id));
  const allLibrariesForGrid = [
    ...(suggestedLibrary && aiSuggestionAccepted === true ? [{
      _id: suggestedLibrary._id,
      name: cleanDisplayName(suggestedLibrary.name),
      group_count: suggestedLibrary.group_count || 0,
      _isAI: true,
      _isPublic: true
    }] : []),
    ...slotPublicLibs.map(lib => ({
      ...lib,
      name: cleanDisplayName(lib.name),
      _isAI: false,
      _isPublic: true
    })),
    ...myLibraries.filter(lib => lib._id !== suggestedId).map(lib => ({
      ...lib,
      _isAI: false,
      _isPublic: false
    }))
  ];

  // Groups not in any currently selected library (legacy groups)
  const manualOnlyGroups = campaignGroups.filter(id =>
    !allLibraryGroups.some(g => g._id === id)
  );

  // ── Refs for async callbacks ──
  const campaignGroupsRef = React.useRef(campaignGroups);
  React.useEffect(() => { campaignGroupsRef.current = campaignGroups; }, [campaignGroups]);
  const campaignBlacklistedGroupsRef = React.useRef(campaignBlacklistedGroups);
  React.useEffect(() => { campaignBlacklistedGroupsRef.current = campaignBlacklistedGroups; }, [campaignBlacklistedGroups]);
  const manualOnlyGroupsRef = React.useRef(manualOnlyGroups);
  React.useEffect(() => { manualOnlyGroupsRef.current = manualOnlyGroups; }, [manualOnlyGroups]);
  const selectedLibraryIdsRef = React.useRef(selectedLibraryIds);
  React.useEffect(() => { selectedLibraryIdsRef.current = selectedLibraryIds; }, [selectedLibraryIds]);
  const pausedLibraryIdsRef = React.useRef(pausedLibraryIds);
  React.useEffect(() => { pausedLibraryIdsRef.current = pausedLibraryIds; }, [pausedLibraryIds]);

  // Toggle = pause/resume, never delete. Off → moves to paused (stays listed, not published).
  const toggleLibrary = (libId: string) => {
    const isOn = selectedLibraryIds.includes(libId);
    setSelectedLibraryIds(prev => isOn ? prev.filter(id => id !== libId) : [...prev, libId]);
    setPausedLibraryIds(prev => isOn ? (prev.includes(libId) ? prev : [...prev, libId]) : prev.filter(id => id !== libId));
  };
  // Explicit removal of a paused library from this campaign (with confirm).
  const removePausedLibrary = (libId: string, libName: string) => {
    if (!window.confirm(`להסיר את "${libName}" מהקמפיין? (כדי להחזיר יהיה צריך להוסיף אותה מחדש)`)) return;
    setPausedLibraryIds(prev => prev.filter(id => id !== libId));
    setSlotLibraries(prev => prev.filter(l => l._id !== libId));
  };

  // ── Save functions ──
  const doSave = async () => {
    if (campaign._id) {
      try {
        setSaved(true);
        const savedGroups = manualOnlyGroupsRef.current;
        const savedLibraries = selectedLibraryIdsRef.current;
        const savedPaused = pausedLibraryIdsRef.current;
        const savedBlacklist = campaignBlacklistedGroupsRef.current;
        await axios.post(`${API_URL}/api/save-campaign-groups`, {
          campaignGroups: savedGroups,
          campaignBlacklistedGroups: savedBlacklist,
          campaignUsers: campaignUsers,
          selectedLibraries: savedLibraries,
          pausedLibraries: savedPaused,
          _id: campaign._id
        });
        // Update parent so reopening the modal doesn't restore old groups
        if (ddddddddddd) {
          ddddddddddd({ ...campaign, groups: savedGroups, blacklisted_groups: savedBlacklist, _libraryIds: savedLibraries, _groupCount: allSelectedGroupIds.length + acctExtrasInSelected });
        }
        const dismissBtn = document.querySelector('#kt_modal_8 [data-bs-dismiss="modal"]') as HTMLElement;
        dismissBtn?.click();
      } catch (e) {
        alert('error')
      }
    }
  }

  const handleMainSave = async () => {
    if (manualOnlyGroups.length > 0) {
      setShowNamingDialog(true);
    } else {
      doSave();
    }
  }

  // ── Effects ──

  // Fetch occupation
  useEffect(() => {
    if (currentUser?.library_occupation) {
      const occ = currentUser.library_occupation;
      setLibraryOccupation(occ);
      setLoadingOccupation(false);
      return;
    }
    const fetchOccupation = async () => {
      setLoadingOccupation(true);
      try {
        const response = await axios.get(`${API_URL}/api/library-occupation`);
        if (response.data.success) {
          setLibraryOccupation(response.data.library_occupation);
        }
      } catch (e) {
        console.error('Error fetching occupation:', e);
      } finally {
        setLoadingOccupation(false);
      }
    };
    fetchOccupation();
  }, []);

  // Fetch public libraries (for AI suggestion and admin picker)
  useEffect(() => {
    if (isAdmin) { /* always fetch for admin */ }
    else if (!showLibraryFeature && libraryOccupation !== null) return;
    const fetchLibraries = async () => {
      setLoadingLibraries(true);
      try {
        const response = await axios.get(`${API_URL}/api/public-libraries${isAdmin ? '?all=true' : ''}`);
        if (response.data.success) {
          setPublicLibraries(response.data.libraries || []);
        }
      } catch (e) {
        console.error('Error fetching libraries:', e);
      } finally {
        setLoadingLibraries(false);
      }
    };
    fetchLibraries();
  }, [isAdmin, showLibraryFeature, libraryOccupation]);

  // AI suggest library
  useEffect(() => {
    if (slotLoaded && !suggestedLibrary && campaign._id && !aiSelectingLibrary && aiSuggestionAccepted === null && showLibraryFeature) {
      const suggestLibrary = async () => {
        setAiSelectingLibrary(true);
        try {
          const postsResponse = await axios.get(`${API_URL}/api/campaign-posts/${campaign._id}`);
          const posts = postsResponse.data.posts || [];
          const response = await axios.post(`${API_URL}/api/suggest-library`, {
            campaignId: campaign._id,
            campaignName: campaign.name,
            posts: posts.map(p => ({ name: p.name, content: p.content, type: p.type }))
          });
          if (response.data.success && response.data.suggestedLibrary) {
            const suggested = response.data.suggestedLibrary;
            setSuggestedLibrary({ ...suggested, reason: response.data.reason });
            setAiSuggestionAccepted(true);
            setLibraryError(null);
          } else if (response.data.noLibraryFound) {
            setLibraryError({ message: response.data.message, ticketNumber: response.data.ticketNumber, requestedCity: response.data.requestedCity });
            setAiSuggestionAccepted(false);
          } else {
            setAiSuggestionAccepted(false);
          }
        } catch (e) {
          console.error('Error suggesting library:', e);
          setLibraryError({ message: 'שגיאה בחיפוש ספריית קבוצות מתאימה' });
          setAiSuggestionAccepted(false);
        } finally {
          setAiSelectingLibrary(false);
        }
      };
      suggestLibrary();
    }
  }, [slotLoaded, suggestedLibrary, campaign._id, campaign.name, aiSelectingLibrary, aiSuggestionAccepted, showLibraryFeature]);

  // Fetch groups for all selected libraries
  useEffect(() => {
    if (selectedLibraryIds.length === 0) {
      setAllLibraryGroups([]);
      return;
    }
    const fetchAllLibraryGroups = async () => {
      setLoadingLibraryGroups(true);
      try {
        const results = await Promise.allSettled(
          selectedLibraryIds.map(id => axios.get(`${API_URL}/api/library-groups/${id}`))
        );
        const merged = new Map();
        const perLib: Record<string, any[]> = {};
        results.forEach((result, i) => {
          if (result.status !== 'fulfilled') return;
          const groups = result.value.data.groups || [];
          perLib[selectedLibraryIds[i]] = groups;
          groups.forEach(g => {
            if (!merged.has(g._id)) merged.set(g._id, g);
          });
        });
        setPerLibraryGroups(prev => ({ ...prev, ...perLib }));
        setAllLibraryGroups(Array.from(merged.values()));
      } catch (e) {
        console.error('Error fetching library groups:', e);
        setAllLibraryGroups([]);
      } finally {
        setLoadingLibraryGroups(false);
      }
    };
    fetchAllLibraryGroups();
  }, [selectedLibraryIds]);

  // Fetch private libraries
  useEffect(() => {
    const fetchMyLibraries = async () => {
      setLoadingMyLibraries(true);
      try {
        const response = await axios.get(`${API_URL}/api/my-libraries`);
        if (response.data.success) {
          setMyLibraries(response.data.libraries || []);
        }
      } catch (e) {
        console.error('Error fetching my libraries:', e);
      } finally {
        setLoadingMyLibraries(false);
      }
    };
    fetchMyLibraries();
  }, []);

  // Reset on campaign change
  useEffect(() => {
    setCampaignGroups(campaign.groups || []);
    setCampaignLibraryGroups(campaign.library_groups || []);
    setCampaignBlacklistedGroups(campaign.blacklisted_groups || []);
    setSuggestedLibrary(null);
    setSelectedLibraryIds([]);
    setPausedLibraryIds([]);
    setSlotLibraries([]);
    setAiSuggestionAccepted(null);
    setAllLibraryGroups([]);
    setLibraryError(null);
    setSlotLoaded(false);
    setActiveView({ type: 'library-list' });
  }, [campaign._id]);

  // Update parent with correct count
  useEffect(() => {
    if (!slotLoaded) return;
    // Push the SAME number the modal shows. This is what the dashboard's "קבוצות (N)"
    // button renders, so using the raw selection here made closing the modal replace a
    // correct count with one that omitted the account's own groups.
    if (selectedCountDisplay !== campaign._groupCount && ddddddddddd) {
      ddddddddddd({ ...campaign, _groupCount: selectedCountDisplay });
    }
  }, [selectedCountDisplay, slotLoaded]);

  // Fetch campaign slot data
  useEffect(() => {
    if (campaign._id) {
      setSlotLoaded(false);
      axios.get(`${API_URL}/api/get-campaign-slot/${campaign._id}`)
        .then(async response => {
          if (response.data.success) {
            const userIds = (response.data.users || []).map(u => u._id || u);
            setCampaignUsers(userIds);
            const selectedGroups = response.data.selected_groups || [];
            if (selectedGroups.length > 0) setCampaignGroups(selectedGroups);
            const blacklistedGroups = response.data.blacklisted_groups || [];
            if (blacklistedGroups.length > 0) setCampaignBlacklistedGroups(blacklistedGroups);
            const libraries = response.data.group_libraries || [];
            if (libraries.length > 0) {
              const libIds = libraries.map(l => l._id || l);
              setSelectedLibraryIds(libIds);
              // Track libraries that came from the slot (public libs assigned by admin/AI)
              const slotLibObjs = libraries.filter(l => l._id && l.name).map(l => ({
                _id: l._id,
                name: l.name,
              }));
              setSlotLibraries(slotLibObjs);
            }
            // Paused libraries stay in the list (as "מושהה"), they just aren't published to.
            const paused = (response.data.paused_libraries || []).filter((l: any) => l && l._id);
            if (paused.length > 0) {
              const activeIds = new Set(libraries.map(l => l._id || l));
              const pausedObjs = paused.filter((l: any) => !activeIds.has(l._id));
              setPausedLibraryIds(pausedObjs.map((l: any) => l._id));
              setSlotLibraries(prev => [...prev, ...pausedObjs.filter((l: any) => l.name && !prev.some(p => p._id === l._id)).map((l: any) => ({ _id: l._id, name: l.name }))]);
            }
          }
        })
        .catch(e => console.error('Error fetching campaign slot:', e))
        .finally(() => setSlotLoaded(true));
    }
  }, [campaign._id]);

  // Auto-save when library selection changes
  const librarySelectionInitialized = React.useRef(false);
  useEffect(() => {
    if (!slotLoaded) return;
    if (!librarySelectionInitialized.current) {
      librarySelectionInitialized.current = true;
      return;
    }
    if (!campaign._id) return;
    const autoSaveLibraries = async () => {
      setSavingLibrarySelection(true);
      try {
        await axios.post(`${API_URL}/api/save-campaign-groups`, {
          campaignGroups: manualOnlyGroupsRef.current,
          campaignBlacklistedGroups: campaignBlacklistedGroupsRef.current,
          campaignUsers: [],
          selectedLibraries: selectedLibraryIds,
          pausedLibraries: pausedLibraryIds,
          _id: campaign._id
        });
        setLibrarySaved(true);
        setTimeout(() => setLibrarySaved(false), 1500);
      } catch (e) {
        console.error('Error auto-saving library selection:', e);
      } finally {
        setSavingLibrarySelection(false);
      }
    };
    autoSaveLibraries();
  }, [selectedLibraryIds, pausedLibraryIds, slotLoaded, campaign._id]);

  useEffect(() => {
    librarySelectionInitialized.current = false;
  }, [campaign._id]);

  // Load every library's account-added count up front, so the cards are right on first
  // paint instead of only after a library's edit view has been opened.
  React.useEffect(() => {
    axios.get(`${API_URL}/api/account-library-groups-counts`)
      .then(res => {
        if (res.data?.success && res.data.counts) {
          // Merge, don't replace: a library opened before this resolves already has a
          // fresher count from its own fetch.
          setAcctLibCounts(prev => ({...res.data.counts, ...prev}));
        }
      })
      .catch(() => {});
  }, []);

  // Bring the search-results section into view when a query first returns something.
  React.useEffect(() => {
    if (!acctLibResults.length) { lastScrolledQueryRef.current = ''; return; }
    const q = searchInputValue.trim();
    if (!q || lastScrolledQueryRef.current === q) return;
    lastScrolledQueryRef.current = q;
    // Next frame, so the rows exist and the anchor has its final position.
    requestAnimationFrame(() => {
      globalResultsAnchorRef.current?.scrollIntoView({behavior: 'smooth', block: 'start'});
    });
  }, [acctLibResults, searchInputValue]);

  // Ref for editViewGroups so the search effect doesn't re-trigger on every group toggle
  const editViewGroupsRef = React.useRef(editViewGroups);
  React.useEffect(() => { editViewGroupsRef.current = editViewGroups; }, [editViewGroups]);

  // Edit view: fetch groups (debounced + cancel-stale)
  const [editViewCount, setEditViewCount] = useState(0);
  useEffect(() => {
    if (activeView.type !== 'edit-library' && activeView.type !== 'create-library') return;
    let cancelled = false;
    const fetchGroups = async () => {
      setEditViewSearchLoading(true);
      try {
        if (editViewFilterBy === 'my_groups') {
          // Tags go over as a list, not one joined string: joined, "נדל" + "תל אביב"
          // became the regex /נדל תל אביב/ and matched nothing, so a second tag
          // emptied the results. The server ORs the tags like the main search does.
          const searchTags = tags.map(t => t.id).filter(Boolean);
          const data = await axios.get(`${API_URL}/api/my-profile-groups`, {
            params: { search: searchTags.join(' '), search_tags: JSON.stringify(searchTags), profile_id: myGroupsSelectedProfile }
          });
          if (cancelled) return;
          const results = data.data.groups || [];
          setEditViewCount(data.data.count || results.length);
          setEditViewSearchResults(results);
          if (data.data.profiles && data.data.profiles.length > 0) {
            setMyGroupsProfiles(data.data.profiles);
          }
        } else {
          let groupsToSend: any[] = [];
          if (editViewFilterBy === 'selected' || editViewFilterBy === 'not_selected') {
            groupsToSend = editViewGroupsRef.current.map(g => g._id);
          }
          const data = await axios.post(`${API_URL}/api/groups`, {
            sort_by: '',
            filter: '',
            search_tags: tags,
            filter_by: editViewFilterBy,
            groups: groupsToSend,
            campaignBlacklistedGroups: []
          });
          if (cancelled) return;
          const results = data.data.groups || [];
          setEditViewCount(data.data.count || results.length);
          setEditViewSearchResults(results);
        }
      } catch (e) {
        if (!cancelled) console.error('Error searching groups:', e);
      } finally {
        if (!cancelled) setEditViewSearchLoading(false);
      }
    };
    const timer = setTimeout(fetchGroups, 350);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [tags, activeView.type, editViewFilterBy, myGroupsSelectedProfile]);

  const tutParams = new URLSearchParams(window.location.search);
  const isTutorialLibraryStep = tutParams.has('tut') && tutParams.get('step') === '6';

  return (
    <div className={`select-groups-modal${isTutorialLibraryStep ? ' tutorial-mode' : ''}`} style={{direction: 'rtl'}}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes pulse { 0%, 100% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.1); opacity: 0.8; } }
        @keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
        @keyframes cardSlideIn { from { opacity: 0; transform: translateY(12px) scale(0.97); } to { opacity: 1; transform: translateY(0) scale(1); } }
        @keyframes togglePop { 0% { transform: scale(1); } 40% { transform: scale(1.25); } 100% { transform: scale(1); } }
        @keyframes glowPulse { 0%, 100% { box-shadow: 0 2px 8px rgba(34,197,94,0.12); } 50% { box-shadow: 0 4px 20px rgba(34,197,94,0.3); } }
        @keyframes countUp { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes stripePulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.6; } }
        @keyframes barGrow { from { width: 0%; } }

        .lib-toggle { position: relative; width: 44px; height: 24px; border-radius: 12px; cursor: pointer; transition: all 0.3s cubic-bezier(.4,0,.2,1); border: none; padding: 0; flex-shrink: 0; box-shadow: inset 0 1px 3px rgba(0,0,0,0.15); }
        .lib-toggle.on { background: linear-gradient(135deg, #22c55e, #16a34a); box-shadow: inset 0 1px 3px rgba(0,0,0,0.1), 0 0 8px rgba(34,197,94,0.3); }
        .lib-toggle.off { background: #d1d5db; }
        .lib-toggle .lib-toggle-knob { position: absolute; top: 2px; width: 20px; height: 20px; border-radius: 50%; background: #fff; box-shadow: 0 1px 4px rgba(0,0,0,0.25); transition: all 0.3s cubic-bezier(.4,0,.2,1); display: flex; align-items: center; justify-content: center; }
        .lib-toggle.on .lib-toggle-knob { left: 2px; animation: togglePop 0.35s cubic-bezier(.4,0,.2,1); }
        .lib-toggle.off .lib-toggle-knob { left: 22px; }
        .lib-toggle.on .lib-toggle-knob::after { content: '✓'; font-size: 10px; color: #22c55e; font-weight: 700; }
        .lib-toggle:active { transform: scale(0.92); }

        .lib-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; }
        @media (max-width: 900px) { .lib-grid { grid-template-columns: repeat(3, 1fr); } }
        @media (max-width: 600px) { .lib-grid { grid-template-columns: repeat(2, 1fr); } }

        .lib-card { position: relative; display: flex; flex-direction: column; align-items: center; border-radius: 16px; border: 1.5px solid #e5e7eb; background: #fff; transition: all 0.3s cubic-bezier(.4,0,.2,1); overflow: hidden; cursor: default; animation: cardSlideIn 0.4s cubic-bezier(.4,0,.2,1) backwards; padding: 14px 8px 10px; text-align: center; }
        .lib-card:hover { border-color: #d1d5db; box-shadow: 0 6px 20px rgba(0,0,0,0.1); transform: translateY(-2px); }
        .lib-card.selected { border-color: #86efac; background: linear-gradient(135deg, #f0fdf4, #dcfce7); animation: cardSlideIn 0.4s cubic-bezier(.4,0,.2,1) backwards, glowPulse 3s ease-in-out infinite; }
        .lib-card.selected:hover { box-shadow: 0 6px 24px rgba(34,197,94,0.25); transform: translateY(-2px); }
        .lib-card.legacy { border: 1.5px dashed #fbbf24; background: linear-gradient(135deg, #fffbeb, #fef3c7); }

        .lib-card-stripe { display: none; }

        .lib-card-body { display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 0; min-width: 0; width: 100%; }

        .lib-card-icon { width: 44px; height: 44px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; transition: transform 0.3s cubic-bezier(.4,0,.2,1); }
        .lib-card:hover .lib-card-icon { transform: scale(1.1) rotate(-3deg); }
        .lib-card-icon.ai { background: linear-gradient(135deg, #dcfce7, #bbf7d0); }
        .lib-card-icon.public { background: linear-gradient(135deg, #dbeafe, #bfdbfe); }
        .lib-card-icon.private { background: linear-gradient(135deg, #f3f4f6, #e5e7eb); }
        .lib-card-icon.legacy { background: linear-gradient(135deg, #fef3c7, #fde68a); }

        .lib-card-info { min-width: 0; width: 100%; }
        .lib-card-name { font-size: 11px; font-weight: 700; color: #1a1a1a; white-space: normal; word-break: break-word; line-height: 1.3; }
        .lib-card-meta { font-size: 10px; color: #6b7280; margin-top: 2px; display: flex; align-items: center; justify-content: center; gap: 4px; }
        .lib-card-badge { font-size: 9px; padding: 1px 5px; border-radius: 6px; font-weight: 700; white-space: nowrap; letter-spacing: 0.02em; }

        .lib-card-count { font-size: 11px; font-weight: 700; color: #6b7280; display: flex; flex-direction: column; align-items: center; flex-shrink: 0; margin-top: 2px; }
        .lib-card-count .count-num { font-size: 18px; line-height: 1; color: #1a1a1a; transition: all 0.3s cubic-bezier(.4,0,.2,1); }
        .lib-card.selected .lib-card-count .count-num { color: #16a34a; animation: countUp 0.4s cubic-bezier(.4,0,.2,1); }
        .lib-card-count .count-label { font-size: 9px; color: #9ca3af; font-weight: 500; }

        .lib-card-bar { position: absolute; bottom: 0; left: 0; right: 0; height: 3px; background: #f3f4f6; }
        .lib-card-bar-fill { height: 100%; border-radius: 0 0 2px 2px; transition: width 0.8s cubic-bezier(.4,0,.2,1); animation: barGrow 0.8s cubic-bezier(.4,0,.2,1); }
        .lib-card-bar-fill.green { background: linear-gradient(90deg, #22c55e, #16a34a); }
        .lib-card-bar-fill.amber { background: linear-gradient(90deg, #f59e0b, #d97706); }

        .lib-card-actions { display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 4px; margin-top: 6px; opacity: 0.7; transition: opacity 0.2s; }
        .lib-card:hover .lib-card-actions { opacity: 1; }
        .lib-card-edit { padding: 4px 8px; border-radius: 8px; border: 1.5px solid #3b82f6; background: #eff6ff; color: #2563eb; font-size: 10px; font-weight: 600; cursor: pointer; flex-shrink: 0; transition: all 0.25s cubic-bezier(.4,0,.2,1); display: flex; align-items: center; gap: 3px; white-space: nowrap; }
        .lib-card-edit:hover { background: #dbeafe; border-color: #2563eb; color: #1d4ed8; transform: translateY(-1px) scale(1.03); box-shadow: 0 4px 12px rgba(59,130,246,0.25); }
        .lib-card-edit:active { transform: scale(0.97); }
        .lib-card-delete { padding: 4px 8px; border-radius: 8px; border: 1.5px solid #e5e7eb; background: #fff; color: #9ca3af; font-size: 10px; font-weight: 600; cursor: pointer; flex-shrink: 0; transition: all 0.25s cubic-bezier(.4,0,.2,1); display: flex; align-items: center; gap: 3px; white-space: nowrap; }
        .lib-card-delete:hover { border-color: #fecaca; color: #dc2626; background: #fef2f2; transform: translateY(-1px) scale(1.08); box-shadow: 0 3px 10px rgba(220,38,38,0.15); }
        .lib-card-delete:active { transform: scale(0.92); }


      `}</style>

      {/* ══════════ Naming Dialog (force-convert legacy groups) ══════════ */}
      {showNamingDialog && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10020, pointerEvents: 'auto',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{
            background: '#fff', borderRadius: '16px', padding: '24px', width: '400px', maxWidth: '90vw',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)', direction: 'rtl'
          }} onClick={e => e.stopPropagation()}>
            <div style={{ textAlign: 'center', marginBottom: '16px' }}>
              <div style={{ fontSize: '40px', marginBottom: '8px' }}>📚</div>
              <div style={{ fontSize: '16px', fontWeight: 700, color: '#1a1a1a' }}>שמור כספריית קבוצות</div>
              <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '4px' }}>
                יש לך {manualOnlyGroups.length} קבוצות שלא שייכות לאף ספריית קבוצות. שמור אותן כספריית קבוצות לשימוש חוזר בקמפיינים אחרים.
              </div>
            </div>
            <input
              type="text"
              value={legacyLibraryName}
              onChange={e => setLegacyLibraryName(e.target.value)}
              placeholder="שם ספריית הקבוצות..."
              autoFocus
              style={{
                width: '100%', padding: '10px 14px', borderRadius: '8px',
                border: '2px solid #f59e0b', fontSize: '14px', direction: 'rtl',
                marginBottom: '12px', boxSizing: 'border-box'
              }}
            />
            <button
              onClick={async () => {
                if (!legacyLibraryName.trim()) return;
                setSavingLibrary(true);
                try {
                  const response = await axios.post(`${API_URL}/api/create-library`, {
                    name: legacyLibraryName.trim(),
                    groupIds: [...manualOnlyGroups]
                  });
                  if (response.data.success) {
                    const newLib = response.data.library;
                    setMyLibraries(prev => [...prev, newLib]);
                    setSelectedLibraryIds(prev => [...prev, newLib._id]);
                    setCampaignGroups([]);
                    // Update refs immediately so doSave sends correct data
                    manualOnlyGroupsRef.current = [];
                    selectedLibraryIdsRef.current = [...selectedLibraryIdsRef.current, newLib._id];
                  }
                } catch (e) {
                  console.error('Error creating library:', e);
                } finally {
                  setSavingLibrary(false);
                  setLegacyLibraryName('');
                  setShowNamingDialog(false);
                  doSave();
                }
              }}
              disabled={!legacyLibraryName.trim() || savingLibrary}
              style={{
                width: '100%', padding: '12px', borderRadius: '8px', border: 'none',
                background: legacyLibraryName.trim() ? '#f59e0b' : '#d1d5db',
                color: '#fff', fontSize: '14px', fontWeight: 600,
                cursor: legacyLibraryName.trim() ? 'pointer' : 'not-allowed'
              }}
            >
              {savingLibrary ? '...' : '📚 שמור כספריית קבוצות'}
            </button>
          </div>
        </div>
      )}

      {/* ══════════ Admin: Public Library Picker Popup ══════════ */}
      {showPublicLibraryPicker && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10020, pointerEvents: 'auto',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }} onClick={() => setShowPublicLibraryPicker(false)}>
          <div style={{
            background: '#fff', borderRadius: '16px', padding: '24px', width: '500px', maxWidth: '90vw',
            maxHeight: '70vh', display: 'flex', flexDirection: 'column',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)', direction: 'rtl'
          }} onClick={e => e.stopPropagation()}>
            <div style={{ textAlign: 'center', marginBottom: '16px' }}>
              <div style={{ fontSize: '32px', marginBottom: '4px' }}>🌐</div>
              <div style={{ fontSize: '16px', fontWeight: 700, color: '#1a1a1a' }}>הוסף ספרייה ציבורית</div>
            </div>
            <input
              type="text"
              value={publicLibrarySearch}
              onChange={e => setPublicLibrarySearch(e.target.value)}
              placeholder="חפש ספרייה..."
              autoFocus
              style={{
                width: '100%', padding: '10px 14px', borderRadius: '8px',
                border: '2px solid #3b82f6', fontSize: '14px', direction: 'rtl',
                marginBottom: '12px', boxSizing: 'border-box'
              }}
            />
            <div style={{ overflowY: 'auto', flex: 1 }}>
              {publicLibraries
                .filter(lib => {
                  if (!publicLibrarySearch.trim()) return true;
                  return cleanDisplayName(lib.name).toLowerCase().includes(publicLibrarySearch.toLowerCase());
                })
                .map(lib => {
                  const alreadySelected = selectedLibraryIds.includes(lib._id) || pausedLibraryIds.includes(lib._id);
                  return (
                    <div key={lib._id} style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      padding: '10px 12px', borderRadius: '8px', marginBottom: '6px',
                      border: alreadySelected ? '1.5px solid #22c55e' : '1px solid #e5e7eb',
                      background: alreadySelected ? '#f0fdf4' : '#fff',
                      transition: 'all 0.2s'
                    }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '13px', fontWeight: 600, color: '#1f2937' }}>{cleanDisplayName(lib.name)}</div>
                        <div style={{ fontSize: '11px', color: '#6b7280' }}>{lib.group_count} קבוצות</div>
                      </div>
                      <button onClick={() => {
                        if (alreadySelected) {
                          setSelectedLibraryIds(prev => prev.filter(id => id !== lib._id));
                          setPausedLibraryIds(prev => prev.filter(id => id !== lib._id));
                          setSlotLibraries(prev => prev.filter(l => l._id !== lib._id));
                        } else {
                          setSelectedLibraryIds(prev => [...prev, lib._id]);
                          setSlotLibraries(prev => [...prev, { _id: lib._id, name: lib.name }]);
                        }
                      }} style={{
                        padding: '6px 14px', borderRadius: '8px', border: 'none',
                        background: alreadySelected ? '#dc2626' : '#22c55e',
                        color: '#fff', fontSize: '12px', fontWeight: 600, cursor: 'pointer',
                        transition: 'all 0.2s'
                      }}>
                        {alreadySelected ? 'הסר' : 'הוסף'}
                      </button>
                    </div>
                  );
                })}
              {publicLibraries.length === 0 && (
                <div style={{ textAlign: 'center', padding: '20px', color: '#9ca3af', fontSize: '13px' }}>
                  {loadingLibraries ? 'טוען...' : 'אין ספריות ציבוריות'}
                </div>
              )}
            </div>
            <button onClick={() => { setShowPublicLibraryPicker(false); setPublicLibrarySearch(''); }} style={{
              marginTop: '12px', width: '100%', padding: '10px', borderRadius: '8px', border: 'none',
              background: '#3b82f6', color: '#fff', fontSize: '14px', fontWeight: 600, cursor: 'pointer'
            }}>
              סגור
            </button>
          </div>
        </div>
      )}

      {/* ══════════ VIEW 1: Library List ══════════ */}
      {activeView.type === 'library-list' && (
        <>
          {/* Header */}
          <div className="sg-header">
            {!saved && (
              <>
                <div className="sg-selection-counter">
                  <div className="sg-counter-badge">
                    <span className="sg-counter-number">{selectedCountDisplay}</span>
                    <span className="sg-counter-label">קבוצות נבחרו</span>
                    <span className="sg-campaign-name">לקמפיין: {cleanDisplayName(campaign.name)}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: 'auto' }}>
                    {savingLibrarySelection && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '10px', color: '#6b7280', fontWeight: 500 }}>
                        <span style={{ width: '12px', height: '12px', border: '2px solid #e5e7eb', borderTopColor: '#f59e0b', borderRadius: '50%', animation: 'spin 0.6s linear infinite', display: 'inline-block' }}></span>
                        שומר...
                      </span>
                    )}
                    {!savingLibrarySelection && librarySaved && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', fontSize: '10px', color: '#16a34a', fontWeight: 600 }}>✓ נשמר</span>
                    )}
                    <button className="sg-close-btn" data-bs-dismiss="modal" aria-label="Close">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                    </button>
                  </div>
                </div>

                {/* Description */}
                <div style={{ padding: '6px 14px', fontSize: '12px', color: '#6b7280', borderBottom: '1px solid #f3f4f6', textAlign: 'center' }}>
                  הפעל/כבה ספריות קבוצות לקמפיין. כיבוי משהה את הספרייה בלי למחוק אותה. לחץ על ✏️ לעריכת ספריית קבוצות.
                </div>
              </>
            )}
          </div>

          {/* Content */}
          <div className="sg-content" style={{ paddingBottom: '80px' }}>
            {/* Success Message */}
            {saved && (
              <div className="sg-success-message">
                <div className="sg-success-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" fill="#22c55e"/><path d="M8 12l3 3 5-6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </div>
                <h3>הקבוצות נשמרו בהצלחה!</h3>
                <p>רשימת הקבוצות שלך התקבלה בהצלחה והפרסום של הקמפיין יחל ממחר בשעות הבוקר.<br/><br/>הקמפיינרים שלנו יתזמנו עבורך את הפוסטים לקבוצות ויצרפו את הפרופיל שלך לכל הקבוצות שבחרת.</p>
                <button className="sg-success-btn" onClick={() => {
                  const updatedCampaign = { ...campaign, groups: manualOnlyGroups, blacklisted_groups: campaignBlacklistedGroups,
                    library_groups: allLibraryGroups.map(g => g._id), _groupCount: allSelectedGroupIds.length + acctExtrasInSelected,
                    _libraryIds: selectedLibraryIds, _libraryName: suggestedLibrary?.name };
                  ddddddddddd(JSON.parse(JSON.stringify(updatedCampaign)));
                  setTimeout(() => setSaved(false), 2000);
                }} data-bs-dismiss="modal">סיום</button>
              </div>
            )}

            {!saved && (
              <div style={{ padding: '12px 14px' }}>
                {/* Occupation selector */}
                {needsOccupationChoice && (
                  <div style={{ marginBottom: '12px', padding: '12px', borderRadius: '10px', background: '#fffbeb', border: '1px solid #fcd34d' }}>
                    <div style={{ fontSize: '13px', fontWeight: 600, color: '#92400e', marginBottom: '8px', textAlign: 'center' }}>באיזה תחום אתה עובד?</div>
                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'center' }}>
                      {[
                        { value: 'real_estate', label: '🏠 נדל"ן' },
                        { value: 'cars', label: '🚗 רכב' },
                        { value: 'hr', label: '👔 HR' },
                        { value: 'other', label: '📋 אחר' }
                      ].map(opt => (
                        <button key={opt.value} onClick={async () => {
                          setSavingOccupation(true);
                          try {
                            await axios.post(`${API_URL}/api/library-occupation`, { occupation: opt.value });
                            setLibraryOccupation(opt.value);
                            if (onOccupationSave) onOccupationSave(opt.value);
                          } catch (e) { console.error('Error saving occupation:', e); }
                          finally { setSavingOccupation(false); }
                        }} disabled={savingOccupation} style={{
                          padding: '8px 16px', borderRadius: '8px', border: '2px solid #fcd34d',
                          backgroundColor: '#fff', fontSize: '13px', fontWeight: 500,
                          cursor: savingOccupation ? 'wait' : 'pointer', opacity: savingOccupation ? 0.6 : 1
                        }}>{opt.label}</button>
                      ))}
                    </div>
                  </div>
                )}

                {/* AI skeleton while loading */}
                {(aiSelectingLibrary || (showLibraryFeature && !suggestedLibrary && aiSuggestionAccepted === null)) && (
                  <div className="lib-card" style={{ border: '1.5px dashed #86efac', background: 'linear-gradient(135deg, #f0fdf4, #dcfce7)' }}>
                    <div className="lib-card-stripe ai"></div>
                    <div className="lib-card-body" style={{ justifyContent: 'center', gap: '10px' }}>
                      <div style={{ width: '22px', height: '22px', border: '2.5px solid #bbf7d0', borderTopColor: '#22c55e', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }}></div>
                      <span style={{ fontSize: '12px', color: '#166534', fontWeight: 600 }}>🤖 מחפש ספריית קבוצות מתאימה...</span>
                    </div>
                  </div>
                )}

                {/* Loading spinner for libraries */}
                {!aiSelectingLibrary && (loadingLibraries || loadingMyLibraries) && allLibrariesForGrid.length === 0 && (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '16px 0' }}>
                    <div style={{ width: '20px', height: '20px', border: '2px solid #f59e0b', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
                    <span style={{ fontSize: '12px', color: '#92400e' }}>טוען ספריות...</span>
                  </div>
                )}

                {/* Create new library button: above the cards, so customers with many libraries see it without scrolling */}
                <button onClick={() => openCreateView()} style={{
                  width: '100%', padding: '12px', borderRadius: '12px', border: '2px dashed #d1d5db',
                  background: 'linear-gradient(135deg, #fafafa, #f3f4f6)', color: '#6b7280', fontSize: '13px', fontWeight: 600,
                  cursor: 'pointer', marginBottom: '10px', transition: 'all 0.25s cubic-bezier(.4,0,.2,1)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = '#22c55e'; e.currentTarget.style.color = '#166534'; e.currentTarget.style.background = 'linear-gradient(135deg, #f0fdf4, #dcfce7)'; e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(34,197,94,0.15)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = '#d1d5db'; e.currentTarget.style.color = '#6b7280'; e.currentTarget.style.background = 'linear-gradient(135deg, #fafafa, #f3f4f6)'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
                >
                  <span style={{ fontSize: '16px' }}>+</span> צור ספריית קבוצות חדשה
                </button>

                {/* Library rows - grid */}
                <div className="lib-grid">
                {allLibrariesForGrid.map((lib, idx) => {
                  const isSelected = selectedLibraryIds.includes(lib._id);
                  const isPaused = !isSelected && pausedLibraryIds.includes(lib._id);
                  const isAI = lib._isAI;
                  const isPublic = lib._isPublic;
                  const libGroups = perLibraryGroups[lib._id];
                  // Include the account's own extras — a group added here IS scheduled, so
                  // leaving it out of the count made the save look like it hadn't happened.
                  const groupCount = (libGroups?.length ?? lib.group_count) + (acctLibCounts[lib._id] || 0);
                  const blacklistedCount = isSelected && libGroups ? libGroups.filter(g => campaignBlacklistedGroups.includes(g._id)).length : 0;
                  const activeCount = groupCount - blacklistedCount;
                  const barPercent = groupCount > 0 ? (activeCount / groupCount) * 100 : 0;
                  const typeClass = isAI ? 'ai' : isPublic ? 'public' : 'private';

                  return (
                    <div key={lib._id} className={`lib-card ${isSelected ? 'selected' : ''}`} style={{ animationDelay: `${idx * 0.05}s` }}>
                      <button className={`lib-toggle ${isSelected ? 'on' : 'off'}`} title={isSelected ? 'השהה ספרייה' : 'הפעל ספרייה'} onClick={() => {
                        toggleLibrary(lib._id);
                      }} style={{ position: 'absolute', top: '8px', left: '8px', zIndex: 1 }}>
                        <div className="lib-toggle-knob"></div>
                      </button>
                      <div className="lib-card-body">
                        <div className={`lib-card-icon ${typeClass}`}>
                          {isAI ? '🤖' : isPublic ? '🌐' : '📚'}
                        </div>
                        <div className="lib-card-info">
                          <div className="lib-card-name">{lib.name}</div>
                          <div className="lib-card-meta">
                            {isAI && <span className="lib-card-badge" style={{ background: '#dcfce7', color: '#166534' }}>אוטומטית</span>}
                            {isPublic && !isAI && <span className="lib-card-badge" style={{ background: '#dbeafe', color: '#1e40af' }}>ציבורית</span>}
                            {!isPublic && !isAI && <span className="lib-card-badge" style={{ background: '#f3f4f6', color: '#6b7280' }}>פרטית</span>}
                            {isPaused && <span className="lib-card-badge" style={{ background: '#fef3c7', color: '#92400e' }}>⏸ מושהה</span>}
                            {loadingLibraryGroups && isSelected && <span style={{ fontSize: '9px', color: '#9ca3af' }}>טוען...</span>}
                          </div>
                        </div>
                        <div className="lib-card-count">
                          {/* Just the number that's actually being published to for THIS
                              account — library groups minus the ones removed here, plus the
                              ones added here. "N מתוך M" invited the question of what M was
                              and made the personal figure look like a subset of a real one. */}
                          <span className="count-num">{activeCount}</span>
                          <span className="count-label">קבוצות</span>
                        </div>
                      </div>
                      <div className="lib-card-actions">
                        <button className="lib-card-edit" onClick={() => openEditView(lib._id, lib.name, isPublic || isAI)}>✏️ עריכה</button>
                        {isPaused && (isPublic || isAI) && (
                          <button className="lib-card-edit" style={{ color: '#dc2626' }} onClick={(e) => {
                            e.stopPropagation();
                            removePausedLibrary(lib._id, lib.name);
                          }}>✖ הסר מהקמפיין</button>
                        )}
                        {!isPublic && !isAI && (
                          <button className="lib-card-delete" onClick={async (e) => {
                            e.stopPropagation();
                            if (!window.confirm(`למחוק את "${lib.name}"?`)) return;
                            try {
                              await axios.delete(`${API_URL}/api/delete-library/${lib._id}`);
                              setMyLibraries(prev => prev.filter(l => l._id !== lib._id));
                              setSelectedLibraryIds(prev => prev.filter(id => id !== lib._id));
                              setPausedLibraryIds(prev => prev.filter(id => id !== lib._id));
                              selectedLibraryIdsRef.current = selectedLibraryIdsRef.current.filter(id => id !== lib._id);
                            } catch (e) { console.error(e); }
                          }}>🗑 מחיקת ספריה</button>
                        )}
                      </div>
                      {isSelected && <div className="lib-card-bar"><div className={`lib-card-bar-fill green`} style={{ width: `${barPercent}%` }}></div></div>}
                    </div>
                  );
                })}

                {/* Legacy groups card */}
                {manualOnlyGroups.length > 0 && (
                  <div className="lib-card legacy">
                    <button className="lib-toggle on" style={{ position: 'absolute', top: '8px', left: '8px', zIndex: 1, cursor: 'default', opacity: 0.5 }} disabled>
                      <div className="lib-toggle-knob"></div>
                    </button>
                    <div className="lib-card-body">
                      <div className="lib-card-icon legacy">⚠️</div>
                      <div className="lib-card-info">
                        <div className="lib-card-name">ללא שם</div>
                        <div className="lib-card-meta">
                          <span style={{ color: '#92400e', fontSize: '10px' }}>לחץ עריכה לשמור</span>
                        </div>
                      </div>
                      <div className="lib-card-count">
                        <span className="count-num" style={{ color: '#d97706' }}>{manualOnlyGroups.length}</span>
                        <span className="count-label">קבוצות</span>
                      </div>
                    </div>
                    <div className="lib-card-actions">
                      <button className="lib-card-edit" onClick={() => {
                        axios.post(`${API_URL}/api/groups`, {
                          sort_by: '', filter: '', search_tags: [], filter_by: 'selected',
                          groups: manualOnlyGroups, campaignBlacklistedGroups: []
                        }).then(res => {
                          const legacyGroupObjects = (res.data.groups || []).filter(g => manualOnlyGroups.includes(g._id));
                          openCreateView(legacyGroupObjects);
                        }).catch(() => {
                          openCreateView([]);
                        });
                      }}>✏️ עריכה</button>
                      <button className="lib-card-edit" style={{ color: '#dc2626' }} onClick={() => {
                        if (window.confirm(`למחוק ${manualOnlyGroups.length} קבוצות ללא ספרייה?`)) {
                          setCampaignGroups(prev => prev.filter(id => !manualOnlyGroups.includes(id)));
                        }
                      }}>🗑️ נקה</button>
                    </div>
                    <div className="lib-card-bar"><div className="lib-card-bar-fill amber" style={{ width: '100%' }}></div></div>
                  </div>
                )}
                </div>

                {/* Admin: add public library button */}
                {isAdmin && (
                  <button onClick={() => setShowPublicLibraryPicker(true)} style={{
                    width: '100%', padding: '12px', borderRadius: '12px', border: '2px dashed #3b82f6',
                    background: 'linear-gradient(135deg, #eff6ff, #dbeafe)', color: '#1e40af', fontSize: '13px', fontWeight: 600,
                    cursor: 'pointer', marginTop: '8px', transition: 'all 0.25s cubic-bezier(.4,0,.2,1)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'linear-gradient(135deg, #dbeafe, #bfdbfe)'; e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(59,130,246,0.15)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'linear-gradient(135deg, #eff6ff, #dbeafe)'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
                  >
                    <span style={{ fontSize: '16px' }}>🌐</span> הוסף ספרייה ציבורית (אדמין)
                  </button>
                )}

                {/* Selected library groups preview — grouped by library */}
                {selectedLibraryIds.length > 0 && (() => {
                  let totalReach = 0;
                  const libraryPreviews = selectedLibraryIds.map(libId => {
                    const lib = allLibrariesForGrid.find(l => l._id === libId);
                    const libGroups = perLibraryGroups[libId] || [];
                    if (!lib || libGroups.length === 0) return null;
                    const isAI = lib._isAI;
                    const isPublic = lib._isPublic;
                    const typeColor = isAI ? '#22c55e' : isPublic ? '#3b82f6' : '#6b7280';
                    const activeGroups = libGroups.filter(g => !campaignBlacklistedGroups.includes(g._id));
                    const blacklistedGroups = libGroups.filter(g => campaignBlacklistedGroups.includes(g._id));
                    const libTotalFollowers = activeGroups.reduce((sum, g) => sum + (g.follow_count || 0), 0);
                    totalReach += libTotalFollowers;
                    return (
                      <div key={libId} style={{ background: '#f9fafb', borderRadius: '8px', padding: '8px', border: '1px solid #f3f4f6' }}>
                        <div style={{ fontSize: '11px', fontWeight: 600, color: typeColor, marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '5px', flexWrap: 'wrap' }}>
                          <span style={{ fontSize: '12px' }}>{isAI ? '🤖' : isPublic ? '🌐' : '📚'}</span>
                          {lib.name}
                          <span style={{ fontSize: '10px', color: '#9ca3af', fontWeight: 400 }}>
                            ({activeGroups.length + (acctLibCounts[libId] || 0)})
                          </span>
                          <span style={{ fontSize: '10px', color: '#6b7280', fontWeight: 500, marginLeft: '4px' }}>
                            {formatNumber(libTotalFollowers)} עוקבים
                          </span>
                          <button
                            className="lib-card-edit"
                            onClick={() => openEditView(lib._id, lib.name, isPublic || isAI)}
                            style={{ marginRight: 'auto', fontSize: '10px', padding: '3px 8px' }}
                          >
                            ✏️ עריכת ספריית קבוצות {lib.name}
                          </button>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', maxHeight: '150px', overflowY: 'auto' }}>
                          {[...activeGroups, ...blacklistedGroups].map(group => {
                            const isBlacklisted = campaignBlacklistedGroups.includes(group._id);
                            return (
                              <div key={group._id} style={{
                                display: 'flex', alignItems: 'center', gap: '6px',
                                padding: '2px 4px', borderRadius: '5px',
                                opacity: isBlacklisted ? 0.5 : 1,
                              }}>
                                <div style={{
                                  width: '24px', height: '24px', borderRadius: '5px', overflow: 'hidden',
                                  border: `1.5px solid ${isBlacklisted ? '#fecaca' : typeColor}`,
                                  flexShrink: 0
                                }}>
                                  <img
                                    src={group.image_url || '/media/avatars/blank.png'}
                                    alt={group.name}
                                    onError={(e) => { (e.target as HTMLImageElement).src = '/media/avatars/blank.png' }}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                  />
                                </div>
                                <span style={{ fontSize: '11px', color: isBlacklisted ? '#9ca3af' : '#374151', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1, minWidth: 0 }}>
                                  {group.name}
                                </span>
                                <span style={{ fontSize: '10px', color: isBlacklisted ? '#d1d5db' : '#9ca3af', flexShrink: 0 }}>
                                  {formatNumber(group.follow_count || 0)}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  }).filter(Boolean);
                  if (libraryPreviews.length === 0) return null;
                  return (
                    <div style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      <div style={{ textAlign: 'center', padding: '6px 0', fontSize: '12px', fontWeight: 600, color: '#1e40af', background: '#eff6ff', borderRadius: '8px' }}>
                        חשיפה פוטנציאלית: {formatNumber(totalReach)} עוקבים
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '300px', overflowY: 'auto' }}>
                        {libraryPreviews}
                      </div>
                    </div>
                  );
                })()}
              </div>
            )}
          </div>

          {/* Footer */}
          {!saved && (
            <div className="sg-footer">
              <button className="sg-cancel-btn" data-bs-dismiss="modal">ביטול</button>
              <button className="sg-save-btn" onClick={() => {
                const isTutorial = new URLSearchParams(window.location.search).has('tut');
                if (isTutorial) {
                  if (campaign._id) {
                    axios.post(`${API_URL}/api/save-campaign-groups`, {
                      campaignGroups: manualOnlyGroups, campaignBlacklistedGroups, campaignUsers,
                      selectedLibraries: selectedLibraryIds, pausedLibraries: pausedLibraryIds, _id: campaign._id
                    });
                  }
                  const updatedCampaign = { ...campaign, groups: manualOnlyGroups, blacklisted_groups: campaignBlacklistedGroups,
                    library_groups: allLibraryGroups.map(g => g._id), _groupCount: allSelectedGroupIds.length + acctExtrasInSelected,
                    _libraryIds: selectedLibraryIds, _libraryName: suggestedLibrary?.name };
                  ddddddddddd(JSON.parse(JSON.stringify(updatedCampaign)));
                  const dismissBtn = document.querySelector('#kt_modal_8 [data-bs-dismiss="modal"]') as HTMLElement;
                  dismissBtn?.click();
                } else {
                  handleMainSave();
                }
              }} disabled={selectedCount === 0}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 12l5 5L20 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                שמור ({selectedCountDisplay} קבוצות)
              </button>
            </div>
          )}
        </>
      )}

      {/* ══════════ VIEW 2: Edit Library ══════════ */}
      {(activeView.type === 'edit-library' || activeView.type === 'create-library') && (
        <>
          {/* Header */}
          <div className="sg-header">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', borderBottom: '1px solid #f3f4f6' }}>
              <button onClick={goBackToList} style={{
                display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 10px', borderRadius: '6px',
                border: '1px solid #e5e7eb', background: '#fff', color: '#6b7280', fontSize: '12px', cursor: 'pointer'
              }}>
                ← חזרה לספריות
              </button>
              <span className="lib-row-badge" style={{
                background: activeView.type === 'create-library' ? '#fef3c7' : '#eff6ff',
                color: activeView.type === 'create-library' ? '#92400e' : '#1e40af',
                fontSize: '11px', padding: '2px 8px'
              }}>
                {activeView.type === 'create-library' ? 'ספריית קבוצות חדשה' : 'עריכת ספריית קבוצות'}
              </span>
              <button className="sg-close-btn" data-bs-dismiss="modal" aria-label="Close">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
              </button>
            </div>

            {/* Library name input */}
            <div style={{ padding: '8px 14px', borderBottom: '1px solid #f3f4f6' }}>
              {activeView.type === 'edit-library' && activeView.isPublic ? (
                // Title and explanation were on one line, the explanation in 11px light
                // grey — effectively unreadable. Stack them: a real heading, then a
                // legible subtitle.
                <div style={{ padding: '8px 0' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <span style={{ fontSize: '17px', fontWeight: 800, color: '#111827', lineHeight: 1.25 }}>
                      🌐 {activeView.libraryName}
                    </span>
                    <span style={{ fontSize: '11px', fontWeight: 700, color: '#1e40af', background: '#dbeafe', borderRadius: '6px', padding: '2px 8px', whiteSpace: 'nowrap' }}>
                      ספרייה ציבורית
                    </span>
                  </div>
                  <div style={{ fontSize: '13px', color: '#4b5563', fontWeight: 500, lineHeight: 1.5 }}>
                    כאן אפשר להוסיף או להסיר קבוצות: לחצו על קבוצה ברשימה כדי להסיר אותה, או חפשו מילות מפתח בשורת החיפוש שמתחת כדי להוסיף קבוצות חדשות.
                  </div>
                </div>
              ) : (
                <div style={{width: '100%'}}>
                  <input
                    type="text"
                    value={editViewLibraryName}
                    onChange={e => setEditViewLibraryName(e.target.value)}
                    placeholder="שם ספריית הקבוצות..."
                    autoFocus={activeView.type === 'create-library'}
                    style={{
                      width: '100%', padding: '8px 12px', borderRadius: '8px',
                      border: `2px solid ${activeView.type === 'create-library' && !editViewLibraryName.trim() && editViewGroups.length > 0 ? '#f44336' : '#e5e7eb'}`,
                      fontSize: '14px', fontWeight: 600,
                      direction: 'rtl', boxSizing: 'border-box'
                    }}
                  />
                  {activeView.type === 'create-library' && !editViewLibraryName.trim() && editViewGroups.length > 0 && (
                    <div style={{color: '#f44336', fontSize: '12px', marginTop: '4px', direction: 'rtl', fontWeight: 500}}>
                      * חובה להזין שם לספרייה
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* (Account-scoped "add your own groups" is now merged into the main keyword search + list below.) */}

            {/* Search + Filters */}
            <div className="sg-search-filters-row">
              <div className="sg-search-box">
                <div className="sg-search-input-wrapper">
                  <div className="sg-search-input-tags">
                    <div className="sg-search-icon">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2"/><path d="M20 20l-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                    </div>
                    <ReactTags tags={tags} separators={[SEPARATORS.ENTER, SEPARATORS.COMMA]} handleDelete={handleDelete}
                      placeholder="לדוגמה: תל אביב, ירושלים, חיפה, נדל״ן, רכב יד שניה"
                      handleAddition={handleAddition} handleDrag={handleDrag} handleTagClick={handleTagClick}
                      onTagUpdate={onTagUpdate} handleInputChange={handleSearchInputChange} inputValue={searchInputValue}
                      inputFieldPosition="inline" onClearAll={onClearAll} maxTags={10}
                      classNames={{ tags: 'sg-tags-container', tagInput: 'sg-tag-input', tagInputField: 'sg-tag-input-field', selected: 'sg-selected-tags', tag: 'sg-tag', remove: 'sg-tag-remove' }}
                    />
                  </div>
                  <button type="button" className="sg-add-tag-btn" onClick={handleAddTagClick} disabled={!searchInputValue.trim()}>הוסף</button>
                </div>
              </div>
              {!(activeView.type === 'edit-library' && activeView.isPublic) && (
                <div className="sg-filter-tabs">
                  <button className={`sg-filter-tab ${editViewFilterBy === 'keywords' ? 'active' : ''}`} onClick={() => setEditViewFilterBy('keywords')}>הכל</button>
                  <button className={`sg-filter-tab ${editViewFilterBy === 'my_groups' ? 'active' : ''}`} onClick={() => setEditViewFilterBy('my_groups')} style={editViewFilterBy === 'my_groups' ? {background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', borderColor: '#667eea'} : {}}>👤 הקבוצות שלי</button>
                  <button className={`sg-filter-tab ${editViewFilterBy === 'selected' ? 'active' : ''}`} onClick={() => setEditViewFilterBy('selected')}>נבחרות ({editViewGroups.length})</button>
                  <button className={`sg-filter-tab ${editViewFilterBy === 'not_selected' ? 'active' : ''}`} onClick={() => setEditViewFilterBy('not_selected')}>לא נבחרות</button>
                </div>
              )}

            </div>

            {/* Profile selector for "my groups" filter. It lives OUTSIDE .sg-search-filters-row
                on purpose: that row is a flex line on desktop, and a third item there squeezed
                the search box down to its icon (the tag input measured 0px wide), so picking a
                profile looked like it broke the search. Its own full-width row below instead. */}
            {editViewFilterBy === 'my_groups' && myGroupsProfiles.length > 0 && (
                <div style={{
                  display: 'flex', gap: '8px', flexWrap: 'wrap', padding: '10px 16px',
                  borderBottom: '1px solid #f3f4f6', background: '#fafbfc',
                  alignItems: 'center',
                }}>
                  <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: 500, marginLeft: '4px' }}>בחר פרופיל:</span>
                  {/* All profiles option - only show when multiple profiles */}
                  {myGroupsProfiles.length > 1 && (
                    <div
                      onClick={() => setMyGroupsSelectedProfile('all')}
                      style={{
                        position: 'relative', cursor: 'pointer', transition: '0.2s',
                        opacity: myGroupsSelectedProfile === 'all' ? 1 : 0.5,
                      }}
                    >
                      <div style={{
                        width: '40px', height: '40px', borderRadius: '50%',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        border: myGroupsSelectedProfile === 'all' ? '3px solid #1877f2' : '2px solid #e5e7eb',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#fff', fontSize: '16px', fontWeight: 700,
                      }}>
                        הכל
                      </div>
                      {myGroupsSelectedProfile === 'all' && (
                        <span style={{
                          position: 'absolute', top: '-4px', left: '-4px', width: '16px', height: '16px',
                          borderRadius: '50%', backgroundColor: '#1877f2',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none"><path d="M5 12l5 5L20 7" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </span>
                      )}
                    </div>
                  )}
                  {/* Profile avatars */}
                  {myGroupsProfiles.map((p) => {
                    const isSelected = myGroupsSelectedProfile === p._id;
                    return (
                      <div
                        key={p._id}
                        onClick={() => setMyGroupsSelectedProfile(p._id)}
                        className="profile-avatar-with-tooltip"
                        style={{
                          position: 'relative', cursor: 'pointer', transition: '0.2s',
                          opacity: isSelected ? 1 : 0.6,
                        }}
                      >
                        <span className="profile-tooltip">{p.name}</span>
                        <img
                          src={`https://graph.facebook.com/${p.facebook_id}/picture?type=normal&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`}
                          alt={p.name}
                          style={{
                            width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover',
                            border: isSelected ? '3px solid #1877f2' : '2px solid #e5e7eb',
                            transition: '0.2s',
                          }}
                          onError={(e) => { (e.target as HTMLImageElement).src = '/media/avatars/blank.png' }}
                        />
                        {isSelected && (
                          <span style={{
                            position: 'absolute', top: '-4px', left: '-4px', width: '16px', height: '16px',
                            borderRadius: '50%', backgroundColor: '#1877f2',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                          }}>
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none"><path d="M5 12l5 5L20 7" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/></svg>
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
            )}
          </div>

          {/* Content */}
          <div className="sg-content">
            {/* Loading */}
            {editViewSearchLoading && (
              <div className="sg-loading"><div className="sg-spinner"></div><span>טוען קבוצות...</span></div>
            )}

            {/* Groups count */}
            {!editViewSearchLoading && (() => {
              const isPublicEdit = activeView.type === 'edit-library' && activeView.isPublic;
              if (isPublicEdit && (editViewGroups.length > 0 || editViewGroupsLoading)) {
                // The number that matters is what THIS account publishes to: the library's
                // groups, minus the ones removed here, plus the ones added here. The old
                // figure was the raw library size, so removing or adding a group left it
                // unchanged and the edit looked like it hadn't taken.
                const libIds = new Set(editViewGroups.map((g: any) => g._id.toString()));
                const extrasCount = acctLibGroups.filter((g: any) => !libIds.has(g._id.toString())).length;
                // Total comes from the server; editViewGroups is only the loaded page, so
                // removals can only be counted among what's loaded — right in the common
                // case (a fully-loaded library) and never wildly off.
                const libTotal = editViewGroupsTotal > editViewGroups.length ? editViewGroupsTotal : editViewGroups.length;
                const removedCount = editViewGroups.filter((g: any) => campaignBlacklistedGroups.includes(g._id)).length;
                const effectiveCount = Math.max(0, libTotal - removedCount) + extrasCount;
                return (
                  <div style={{ padding: '4px 12px', fontSize: '12px', color: '#6b7280', textAlign: 'center', borderBottom: '1px solid #f3f4f6' }}>
                    {editViewGroupsLoading ? 'טוען קבוצות...' : `${effectiveCount.toLocaleString()} קבוצות`}
                  </div>
                );
              }
              if (editViewSearchResults.length > 0) {
                return (
                  <div style={{ padding: '4px 12px', fontSize: '12px', color: '#6b7280', textAlign: 'center', borderBottom: '1px solid #f3f4f6' }}>
                    {editViewSearchResults.length < 1000 ? `${editViewSearchResults.length} קבוצות` : `${editViewSearchResults.length} קבוצות (מתוך ${editViewCount.toLocaleString()})`}
                  </div>
                );
              }
              return null;
            })()}

            {/* Unified group list - click to toggle in/out of library */}
            {!editViewSearchLoading && (
              <div className="sg-groups-list">
                {(() => {
                  const isPublicEdit = activeView.type === 'edit-library' && activeView.isPublic;
                  // For public library edit: show library groups with blacklist toggle
                  if (isPublicEdit) {
                    // Merge account-only extra groups into the library list, and expose GLOBAL
                    // search results (all groups) that can be added to THIS account only.
                    const searchTerms = tags.map(t => (t.id || t.text || '').toLowerCase()).filter(Boolean);
                    const nameMatches = (g: any) => searchTerms.length === 0 || searchTerms.some(term => term.split(' ').every(word => (g.name || '').toLowerCase().includes(word)));
                    const libIds = new Set(editViewGroups.map(g => g._id.toString()));
                    const acctLibIds = new Set(acctLibGroups.map((g: any) => g._id.toString()));
                    const liveQuery = (searchInputValue.trim() || tags.map(t => (t.text || t.id || '')).join(' ')).trim();
                    // Search results stay put once added. Previously an added group was filtered
                    // out of the results and reappeared at the top of the library list, so the row
                    // the user had just tapped vanished from under their finger and they couldn't
                    // tell whether it worked. Now the same row simply flips to "added".
                    const globalResults = (liveQuery.length >= 2 ? acctLibResults : []).filter((g: any) => !libIds.has(g._id.toString()));
                    const globalResultIds = new Set(globalResults.map((g: any) => g._id.toString()));
                    const extraGroups = acctLibGroups.filter((g: any) => !libIds.has(g._id.toString()) && !globalResultIds.has(g._id.toString()));
                    // The account's own groups go FIRST. Appended after the library they sat
                    // below hundreds of rows, so with no keyword typed the list looked like it
                    // held nothing but the public library's groups and the ones just added
                    // seemed not to have saved.
                    const filteredGroups = [...extraGroups, ...editViewGroups].filter(nameMatches);
                    return <>{filteredGroups.map((group) => {
                      const isExtra = acctLibIds.has(group._id.toString());
                      const isBlacklisted = !isExtra && campaignBlacklistedGroups.includes(group._id);
                      const isSelected = isExtra ? true : !isBlacklisted;
                      return (
                        <div key={group._id}
                          className={`sg-group-item ${isSelected ? 'selected' : 'blacklisted'}`}
                          style={!isSelected ? { backgroundColor: '#fef2f2', borderColor: '#fecaca' } : {}}
                          onClick={() => {
                            if (isExtra) { removeAcctLibGroup(group._id.toString()); }
                            else { setCampaignBlacklistedGroups(prev => isBlacklisted ? prev.filter(id => id !== group._id) : [...prev, group._id]); }
                          }}
                        >
                          <div className="sg-group-checkbox">
                            {isSelected ? (
                              <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="2" y="2" width="20" height="20" rx="4" fill="#22c55e"/><path d="M7 12l4 4 6-7" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                            ) : (
                              <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="2" y="2" width="20" height="20" rx="4" fill="#ef4444"/><path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="2.5" strokeLinecap="round"/></svg>
                            )}
                          </div>
                          <img className="sg-group-avatar" src={group.image_url || '/media/avatars/blank.png'} alt={group.name} onError={(e) => { e.target.src = '/media/avatars/blank.png' }} />
                          <div className="sg-group-info">
                            <div className="sg-group-name">
                              {group.name}
                              {isExtra && <span style={{ marginInlineStart: 6, fontSize: 10, fontWeight: 700, color: '#1e40af', background: '#e0e9ff', borderRadius: 4, padding: '1px 5px' }}>שלך</span>}
                            </div>
                            <div className="sg-group-meta">
                              <span className="sg-group-followers">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2"/><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2"/></svg>
                                {formatNumber(group.follow_count || 0)} עוקבים
                              </span>
                            </div>
                          </div>
                          {group.group_id && (
                            <a href={`https://facebook.com/groups/${group.group_id}`} target="_blank" rel="noreferrer" className="sg-group-link" onClick={(e) => e.stopPropagation()}>
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                            </a>
                          )}
                        </div>
                      );
                    })}
                    {globalResults.map((group: any, gi: number) => {
                      const isAdded = acctLibIds.has(group._id.toString());
                      return (
                      <div key={'gs-' + group._id}
                        // The scroll target is the first result row itself. A dedicated
                        // anchor element was a grid item in this 5-column list, so even at
                        // height 0 it consumed a whole cell and left a visible hole.
                        ref={gi === 0 ? globalResultsAnchorRef : undefined}
                        className={`sg-group-item${isAdded ? ' selected' : ''}`}
                        onClick={() => { if (acctLibBusy) return; if (isAdded) removeAcctLibGroup(group._id.toString()); else addAcctLibGroup(group); }}>
                        <div className="sg-group-checkbox">
                          {isAdded ? (
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="2" y="2" width="20" height="20" rx="4" fill="#22c55e"/><path d="M7 12l4 4 6-7" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                          ) : (
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="2.5" y="2.5" width="19" height="19" rx="4" fill="#fff" stroke="#94a3b8" strokeWidth="2"/><path d="M12 8v8M8 12h8" stroke="#3b82f6" strokeWidth="2.5" strokeLinecap="round"/></svg>
                          )}
                        </div>
                        <img className="sg-group-avatar" src={group.image_url || '/media/avatars/blank.png'} alt={group.name} onError={(e) => { e.target.src = '/media/avatars/blank.png' }} />
                        <div className="sg-group-info">
                          <div className="sg-group-name">
                            {group.name}
                            {isAdded && <span style={{ marginInlineStart: 6, fontSize: 10, fontWeight: 700, color: '#166534', background: '#dcfce7', borderRadius: 4, padding: '1px 5px' }}>נוסף</span>}
                          </div>
                          <div className="sg-group-meta">
                            <span className="sg-group-followers">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2"/><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2"/></svg>
                              {formatNumber(group.follow_count || 0)} עוקבים
                            </span>
                          </div>
                        </div>
                        <span style={{ fontSize: '12px', color: isAdded ? '#16a34a' : '#0d6efd', fontWeight: 700, whiteSpace: 'nowrap' }}>
                          {isAdded ? '✓ נוסף' : '+ הוסף'}
                        </span>
                      </div>
                      );
                    })}
                    {acctLibSearching && liveQuery.length >= 2 && (
                      <div style={{ padding: '10px', textAlign: 'center', color: '#6b7280', fontSize: '12px' }}>מחפש בכל הקבוצות…</div>
                    )}
                    {editViewGroupsHasMore && !editViewGroupsLoading && (
                      <div style={{ padding: '12px', textAlign: 'center' }}>
                        <button
                          onClick={async () => {
                            setEditViewGroupsLoading(true);
                            try {
                              const res = await axios.get(`${API_URL}/api/library-groups/${activeView.libraryId}?limit=500&skip=${editViewGroups.length}`);
                              if (res.data.success) {
                                const newGroups = res.data.groups || [];
                                setEditViewGroups(prev => [...prev, ...newGroups]);
                                setEditViewGroupsHasMore(res.data.has_more || false);
                                setPerLibraryGroups(prev => ({
                                  ...prev,
                                  [activeView.libraryId]: [...(prev[activeView.libraryId] || []), ...newGroups]
                                }));
                              }
                            } catch (e) { console.error(e); }
                            setEditViewGroupsLoading(false);
                          }}
                          style={{
                            padding: '8px 24px', borderRadius: '8px', fontSize: '13px', fontWeight: 600,
                            border: '1px solid #e5e7eb', background: '#fff', color: '#3b82f6', cursor: 'pointer'
                          }}
                        >
                          טען עוד קבוצות ({editViewGroups.length} מתוך {editViewGroupsTotal.toLocaleString()})
                        </button>
                      </div>
                    )}
                    {editViewGroupsLoading && (
                      <div style={{ padding: '12px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>
                        <span className="spinner-border spinner-border-sm" style={{ marginLeft: '8px' }} />
                        טוען קבוצות...
                      </div>
                    )}
                    </>;
                  }

                  // For private/create: unified list of search results, click to toggle
                  const editGroupIds = new Set(editViewGroups.map(g => g._id));
                  return editViewSearchResults.map((group) => {
                    const isInLibrary = editGroupIds.has(group._id);
                    return (
                      <div key={group._id}
                        className={`sg-group-item ${isInLibrary ? 'selected' : ''}`}
                        onClick={async () => {
                          if (isInLibrary) {
                            // Remove from library
                            if (activeView.type === 'edit-library') {
                              try {
                                await axios.put(`${API_URL}/api/update-library/${activeView.libraryId}`, { removeGroupIds: [group._id] });
                                setEditViewGroups(prev => prev.filter(g => g._id !== group._id));
                                setPerLibraryGroups(prev => ({
                                  ...prev,
                                  [activeView.libraryId]: (prev[activeView.libraryId] || []).filter(g => g._id !== group._id)
                                }));
                                setMyLibraries(prev => prev.map(l => l._id === activeView.libraryId ? { ...l, group_count: Math.max(0, l.group_count - 1) } : l));
                              } catch (e) { console.error(e); }
                            } else {
                              setEditViewGroups(prev => prev.filter(g => g._id !== group._id));
                            }
                          } else {
                            // Add to library
                            if (activeView.type === 'edit-library') {
                              try {
                                await axios.put(`${API_URL}/api/update-library/${activeView.libraryId}`, { addGroupIds: [group._id] });
                                setEditViewGroups(prev => [...prev, group]);
                                setPerLibraryGroups(prev => ({
                                  ...prev,
                                  [activeView.libraryId]: [...(prev[activeView.libraryId] || []), group]
                                }));
                                setMyLibraries(prev => prev.map(l => l._id === activeView.libraryId ? { ...l, group_count: l.group_count + 1 } : l));
                              } catch (e) { console.error(e); }
                            } else {
                              setEditViewGroups(prev => [...prev, group]);
                            }
                          }
                        }}
                      >
                        <div className="sg-group-checkbox">
                          {isInLibrary ? (
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="2" y="2" width="20" height="20" rx="4" fill="#22c55e"/><path d="M7 12l4 4 6-7" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                          ) : (
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="2.5" y="2.5" width="19" height="19" rx="3.5" stroke="#d1d5db" strokeWidth="2"/></svg>
                          )}
                        </div>
                        <img className="sg-group-avatar" src={group.image_url || '/media/avatars/blank.png'} alt={group.name} onError={(e) => { e.target.src = '/media/avatars/blank.png' }} />
                        <div className="sg-group-info">
                          <div className="sg-group-name" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            {group.name}
                            {isInLibrary && (
                              <span style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '10px', backgroundColor: '#dcfce7', color: '#166534', fontWeight: 600, whiteSpace: 'nowrap' }}>בספריית קבוצות ✓</span>
                            )}
                          </div>
                          <div className="sg-group-meta">
                            <span className="sg-group-followers">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2"/><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2"/></svg>
                              {formatNumber(group.follow_count)} עוקבים
                            </span>
                          </div>
                        </div>
                        <a href={`https://facebook.com/groups/${group.group_id}`} target="_blank" rel="noreferrer" className="sg-group-link" onClick={(e) => e.stopPropagation()}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </a>
                      </div>
                    );
                  });
                })()}

                {/* Empty state */}
                {editViewSearchResults.length === 0 && editViewGroups.length === 0 && (
                  <div className="sg-empty-state">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#d1d5db" strokeWidth="2"/><path d="M8 15s1.5-2 4-2 4 2 4 2" stroke="#d1d5db" strokeWidth="2" strokeLinecap="round"/><circle cx="9" cy="9" r="1" fill="#d1d5db"/><circle cx="15" cy="9" r="1" fill="#d1d5db"/></svg>
                    <p>לא נמצאו קבוצות</p>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="sg-footer">
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              {/* Delete button - only for private libraries */}
              {activeView.type === 'edit-library' && !activeView.isPublic && (
                <button onClick={async () => {
                  if (!window.confirm(`למחוק את "${activeView.libraryName}"?`)) return;
                  try {
                    await axios.delete(`${API_URL}/api/delete-library/${activeView.libraryId}`);
                    setMyLibraries(prev => prev.filter(l => l._id !== activeView.libraryId));
                    setSelectedLibraryIds(prev => prev.filter(id => id !== activeView.libraryId));
                    goBackToList();
                  } catch (e) { console.error(e); }
                }} style={{
                  padding: '8px 14px', borderRadius: '8px', border: '1px solid #fecaca',
                  background: '#fff', color: '#dc2626', fontSize: '13px', fontWeight: 600, cursor: 'pointer'
                }}>🗑 מחק</button>
              )}
              <button className="sg-cancel-btn" onClick={goBackToList}>ביטול</button>
            </div>

            {activeView.type === 'edit-library' && !activeView.isPublic && (
              <button className="sg-save-btn" onClick={async () => {
                // Save name change if changed
                if (editViewLibraryName.trim() && editViewLibraryName !== activeView.libraryName) {
                  try {
                    await axios.put(`${API_URL}/api/update-library/${activeView.libraryId}`, { name: editViewLibraryName.trim() });
                    setMyLibraries(prev => prev.map(l => l._id === activeView.libraryId ? { ...l, name: editViewLibraryName.trim() } : l));
                  } catch (e) { console.error(e); }
                }
                // Rebuild allLibraryGroups from perLibraryGroups
                const merged = new Map();
                selectedLibraryIds.forEach(id => {
                  (perLibraryGroups[id] || []).forEach(g => {
                    if (!merged.has(g._id)) merged.set(g._id, g);
                  });
                });
                setAllLibraryGroups(Array.from(merged.values()));
                goBackToList();
              }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 12l5 5L20 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                שמור שינויים
              </button>
            )}

            {activeView.type === 'edit-library' && activeView.isPublic && (
              <button className="sg-save-btn" onClick={() => {
                // Save blacklist state
                if (campaign._id) {
                  axios.post(`${API_URL}/api/save-campaign-groups`, {
                    campaignGroups: manualOnlyGroupsRef.current,
                    campaignBlacklistedGroups: campaignBlacklistedGroupsRef.current,
                    campaignUsers: [],
                    selectedLibraries: selectedLibraryIds,
                    pausedLibraries: pausedLibraryIds,
                    _id: campaign._id
                  });
                }
                // Rebuild allLibraryGroups
                const merged = new Map();
                selectedLibraryIds.forEach(id => {
                  (perLibraryGroups[id] || []).forEach(g => {
                    if (!merged.has(g._id)) merged.set(g._id, g);
                  });
                });
                setAllLibraryGroups(Array.from(merged.values()));
                goBackToList();
              }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 12l5 5L20 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                שמור שינויים
              </button>
            )}

            {activeView.type === 'create-library' && (
              <button className="sg-save-btn" disabled={!editViewLibraryName.trim() || editViewGroups.length === 0 || savingLibrary} onClick={async () => {
                setSavingLibrary(true);
                try {
                  const groupIds = editViewGroups.map(g => g._id);
                  const response = await axios.post(`${API_URL}/api/create-library`, {
                    name: editViewLibraryName.trim(),
                    groupIds
                  });
                  if (response.data.success) {
                    const newLib = response.data.library;
                    setMyLibraries(prev => [...prev, newLib]);
                    setSelectedLibraryIds(prev => [...prev, newLib._id]);
                    setPerLibraryGroups(prev => ({ ...prev, [newLib._id]: editViewGroups }));
                    // Remove groups that are now in the library from manual selection
                    setCampaignGroups(prev => prev.filter(id => !groupIds.includes(id)));
                  }
                } catch (e) {
                  console.error('Error creating library:', e);
                } finally {
                  setSavingLibrary(false);
                  goBackToList();
                }
              }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 12l5 5L20 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                {savingLibrary ? '...' : `צור ספריית קבוצות (${editViewGroups.length} קבוצות)`}
              </button>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export {TablesWidget10}
